import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IQInsightsResponse } from 'sync/iq-insights-service/iq-insights-service.types';
import { RootState } from './root.types';

export const iQInsightsSliceName = 'iQInsights';
const getInitialState: () => {
  id: string;
  insights: IQInsightsResponse;
}[] = () => [];

export const iQInsightsSlice = createSlice({
  name: iQInsightsSliceName,
  initialState: getInitialState(),
  reducers: {
    setIQInsightsResponse: (state, action: PayloadAction<{ id: string; insights: IQInsightsResponse }>) => {
      state.push({
        id: action.payload.id,
        insights: action.payload.insights,
      });
    },
    reset(state) {
      Object.assign(state, getInitialState());
    },
  },
});

export const { setIQInsightsResponse, reset } = iQInsightsSlice.actions;
export default iQInsightsSlice.reducer;

export const selectIQInsightsResponseById = (id: string) => (state: RootState) => {
  return state[iQInsightsSliceName].find((res) => res.id === id)?.insights;
};
